import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loading: WritableSignal<boolean> = signal(false);

  constructor() { }

  get state(){
    return this.loading();
  }

  show(){
    this.loading.set(true);
  }

  close(){
    this.loading.set(false);
  }
}
